<template>
  <div>
    <v-container>
      <div>
        <div style="margin-bottom: 15px;">
          <div class="text-xs-right">
            <v-btn color="primary" outline :loading="loadingExport" @click="dialogExport = true">
              <i class="fas fa-file-export mr-1"></i>
              {{ $t('export') }}
            </v-btn>
          </div>
          <a
            href="javascript:void(0);"
            v-if="!isShow"
            @click="
              isShow = true
              bookingItem = {}
            "
          >
            <div class="add-conversation text-xs-center">
              <i class="fa fa-plus middle"></i>
              {{ $t('add_booking') }}
            </div>
          </a>

          <template v-else>
            <booking-form
              v-model="bookingItem"
              :isShow.sync="isShow"
              :loading="loading"
              @submit="postBookingConfigCalendar"
            >
            </booking-form>
          </template>
        </div>
        <div v-if="loading">
          <div class="spinner text-xs-center mb-5 mt-5">
            <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
          </div>
        </div>
        <div v-else>
          <template v-if="data">
            <div class="text-xs-right mb-2">
              <v-pagination
                v-if="pagelength > 1"
                :total-visible="5"
                v-model="pageNumber"
                :length="pagelength"
                @input="changePage"
              ></v-pagination>
            </div>
            <div
              class="mb-3"
              style="padding: 1.5rem; box-shadow: rgb(0 0 0 / 20%) -1px -1px 5px; border-radius: 24px !important; border: 0px;"
              v-for="(item, index) in data"
              :key="index"
            >
              <div @click="item.toggle = !item.toggle">
                <h3>{{ $t('booking_name') }} : {{ item.booking_name }}</h3>
                <v-layout wrap>
                  <v-flex xs12 sm2 class="pa-2">
                    <v-img
                      :src="item.image_url || '/static/img/assets/_global/default-photo.png'"
                    ></v-img>
                  </v-flex>
                  <v-flex xs12 sm7 class="pa-2">
                    <tr>
                      <td class="primary-color text-xs-right">
                        Google calendar ID :
                      </td>
                      <td style="color:#000; overflow-wrap: anywhere;" class="pl-2">
                        {{ item.google_calendar_id }}
                      </td>
                    </tr>
                    <tr>
                      <td class="primary-color text-xs-right">{{ $t('Description') }} :</td>
                      <td style="color:#000; overflow-wrap: anywhere;" class="pl-2">
                        {{ item.booking_description || '-' }}
                      </td>
                    </tr>
                  </v-flex>

                  <v-flex xs12 sm3 class="text-xs-right">
                    <v-btn
                      fab
                      outline
                      color="primary"
                      class="extra-small ma-1"
                      @click="setEditBooking(item)"
                    >
                      <i class="fas fa-pencil-alt"></i>
                    </v-btn>
                    <v-btn
                      fab
                      outline
                      :loading="loading"
                      color="primary"
                      class="extra-small ma-1"
                      @click="deleteBookingConfigCalendar(item)"
                    >
                      <i class="fa fa-trash middle"></i>
                    </v-btn>
                  </v-flex>
                </v-layout>
                <div class="text-xs-center" style="cursor: pointer">
                  <i
                    aria-hidden="true"
                    v-if="item.toggle"
                    class="v-icon material-icons primary--text"
                    >expand_less</i
                  >
                  <i aria-hidden="true" v-else class="v-icon material-icons primary--text"
                    >expand_more</i
                  >
                </div>
              </div>
              <template v-if="item.toggle">
                <sub-booking :BookingId="item.id"></sub-booking>
              </template>
            </div>
            <div class="text-xs-right">
              <v-pagination
                v-if="pagelength > 1"
                :total-visible="5"
                v-model="pageNumber"
                :length="pagelength"
                @input="changePage"
              ></v-pagination>
            </div>
          </template>
        </div>
      </div>
      <v-dialog v-if="isEdit" persistent v-model="isEdit" max-width="1000">
        <v-card>
          <div class="text-xs-right">
            <v-btn flat small fab @click="isEdit = false">
              <v-icon>
                close
              </v-icon>
            </v-btn>
          </div>
          <v-card-text>
            <div class="intent-item z-border-red" style="padding: 10px 15px 0px;">
              <booking-form
                v-model="bookingItemEdit"
                :isShow.sync="isEdit"
                :loading="loading"
                @submit="putBookingConfigCalendar"
              >
              </booking-form>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog persistent v-model="dialogExport" max-width="500">
        <v-card>
          <div class="text-xs-right">
            <v-btn flat small fab @click="onOpenDialogExport">
              <v-icon>
                close
              </v-icon>
            </v-btn>
          </div>
          <v-card-text>
            <div>
              <v-layout wrap>
                <v-flex xs12 sm6>
                  <div
                    class="form-control pa-1"
                    :class="{ 'has-error': errors.has(`startAtDate`) }"
                  >
                    <label class="mr-3">{{ $t('start_date_export') }}</label>
                    <v-menu
                      :ref="`openStartDate_`"
                      :key="`openStartDate_`"
                      v-model="openStartDate"
                      :close-on-content-click="false"
                      full-width
                      max-width="290px"
                      color="primary"
                    >
                      <template v-slot:activator="{ on }">
                        <input
                          :key="`openStartDate_`"
                          type="text"
                          class="form-control browser-default"
                          :placeholder="$t('Date')"
                          readonly
                          v-model="startAtDate"
                          v-on="on"
                          v-validate="'required'"
                          clearable
                          small
                          :name="`startAtDate`"
                        />
                      </template>
                      <v-date-picker
                        :key="`openStartDate_`"
                        color="primary"
                        v-model="startAtDate"
                        @input="openStartDate = false"
                      ></v-date-picker>
                    </v-menu>
                    <span class="text-error" v-if="errors.has('startAtDate')">{{
                      errors.first('startAtDate')
                    }}</span>
                  </div>
                </v-flex>
                <v-flex xs12 sm6>
                  <div class="form-control pa-1" :class="{ 'has-error': errors.has(`endAtDate_`) }">
                    <label class="mr-3">{{ $t('end_date_export') }}</label>

                    <v-menu
                      :ref="`openEndDate_`"
                      :key="`openEndDate_`"
                      v-model="openEndDate"
                      :close-on-content-click="false"
                      full-width
                      max-width="290px"
                      color="primary"
                    >
                      <template v-slot:activator="{ on }">
                        <input
                          :key="`openEndDate_`"
                          type="text"
                          class="form-control browser-default"
                          :placeholder="$t('Date')"
                          readonly
                          v-model="endAtDate"
                          v-on="on"
                          v-validate="'required'"
                          clearable
                          small
                          :name="`endAtDate_`"
                        />
                      </template>
                      <v-date-picker
                        :key="`openEndDate_`"
                        color="primary"
                        v-model="endAtDate"
                        @input="openEndDate = false"
                      ></v-date-picker>
                    </v-menu>
                    <span class="text-error" v-if="errors.has('endAtDate')">{{
                      errors.first('endAtDate')
                    }}</span>
                  </div>
                </v-flex>
              </v-layout>
              <div class="text-xs-center">
                <small style="color: red" v-if="errorDate">{{
                  $t('please_enter_end_date_than_starting_date')
                }}</small>
              </div>
              <div class="text-xs-center">
                <v-btn color="primary" outline :loading="loadingExport" @click="onExportBooking">
                  <i class="fas fa-file-export mr-1"></i>
                  {{ $t('export') }}
                </v-btn>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import SubBooking from './SubBooking.vue'
import uploadfile from '@/components/elements/uploadfile'
import BookingForm from './BookingForm.vue'
import XLSX from 'xlsx'
import dayjs from 'dayjs'

export default {
  props: ['value', 'auctionId'],
  data() {
    return {
      loadingExport: false,
      pageNumber: 1,
      pagelength: 0,
      isShow: false,
      data: null,
      bookingItem: {},
      bookingItemEdit: {},
      isEdit: false,
      loading: false,
      limit: 5,
      offset: 0,
      dialogExport: false,
      openEndDate: false,
      openStartDate: false,
      startAtDate: dayjs().format('YYYY-MM-DD'),
      endAtDate: dayjs().format('YYYY-MM-DD'),
      errorDate: false
    }
  },
  components: { SubBooking, uploadfile, BookingForm },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  mounted() {
    const vm = this
    vm.getBookingConfigCalendar()
  },
  methods: {
    onOpenDialogExport() {
      const vm = this
      vm.dialogExport = false
      vm.errorDate = false
    },
    onExportBooking() {
      const vm = this
      if (vm.startAtDate < vm.endAtDate) {
        vm.errorDate = false
        vm.exportBooking()
      } else {
        vm.errorDate = true
      }
    },
    async exportBooking() {
      const vm = this
      vm.loadingExport = true
      let page_booking_fields_available = [
        'id',
        'booking_name',
        'booking_description',
        'image_url',
        'created_at',
        'created_by',
        'updated_at',
        'updated_by'
      ]

      let page_sub_booking_fields_available = [
        'id',
        'booking_config_id',
        'sub_booking_name',
        'start_at',
        'end_at',
        'max_available_slot',
        'created_at',
        'created_by',
        'updated_at',
        'updated_by'
      ]

      let page_booking_user_fields_available = [
        'id',
        'userid',
        'booking_config_id',
        'sub_booking_config_id',
        'created_at',
        'created_by',
        'updated_at',
        'updated_by',
        'user_first_name',
        'user_last_name',
        'user_image_url',
        'user_app'
      ]
      let data = {
        pageId: vm.selectedBot.pageid,
        body: {
          page_booking_fields: page_booking_fields_available, // optional
          page_sub_booking_fields: page_sub_booking_fields_available, // optional
          page_booking_user_fields: page_booking_user_fields_available, // optional
          page_sub_booking_start_at: vm.startAtDate, // optional
          page_sub_booking_end_at: vm.endAtDate // optional
        }
      }
      let res = await api.exportBooking(data)
      let json = []
      if (res.result && res.result[0] && res.result[0].page_booking_user_result) {
        res.result[0].page_booking_user_result.map(itemUser => {
          json.push({
            'ไอดีผู้ใช้ (User ID)': itemUser.userid,
            'ไอดีการจอง (Booking ID)': itemUser.booking_config_id,
            'ไอดีการจองย่อย (Sub Booking ID)': itemUser.sub_booking_config_id,
            'สร้างเมื่อ (Created at)': itemUser.created_at,
            'สร้างโดย (Created by)': itemUser.created_by,
            'อัปเดตเมื่อ (Updated at)': itemUser.updated_at,
            'อัปเดตโดย (Updated by)': itemUser.updated_by,
            'ชื่อผู้ใช้ (User first name)': itemUser.user_first_name,
            'นามสกุลผู้ใช้ (User last name)': itemUser.user_last_name,
            'รูปโปรไฟล์ผู้ใช้ (User Image URL)': itemUser.user_image_url,
            'ช่องทางการจอง (User Platform)': itemUser.user_app,
            'ชื่อการจอง (Booking Name)': itemUser.booking_name,
            'รายละเอียดการจอง (Booking description)': itemUser.booking_description,
            'รูปการจอง (Booking Photo)': itemUser.image_url,
            'ชื่อ (Name)': itemUser.sub_booking_name,
            'เริ่มการจอง (Start date)': itemUser.start_at,
            'สิ้นสุดการจอง (End date)': itemUser.end_at,
            'จำนวนการจองสูงสุด (Max available slot)': itemUser.max_available_slot
          })
        })
      }
      const dataWS = XLSX.utils.json_to_sheet(json)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, 'zwiz-auction-summary.csv')
      vm.loadingExport = false
    },
    async putBookingConfigCalendar() {
      const vm = this
      vm.loading = true
      var res = await api.putBookingConfigCalendar({
        pageId: vm.selectedBot.pageid,
        booking_config_id: vm.bookingItemEdit.id,
        body: {
          booking_name: vm.bookingItemEdit.booking_name,
          google_calendar_id: vm.bookingItemEdit.google_calendar_id, // optional
          image_url: vm.bookingItemEdit.image_url,
          booking_description: vm.bookingItemEdit.booking_description
        }
      })
      if (res.success) {
        var data = []
        if (vm.data.length !== 0) {
          vm.data.map(item => {
            if (item.id === vm.bookingItemEdit.id) {
              item = res.result
              item.toggle = false
            }
            data.push(item)
          })
        }
        vm.data = data
        vm.isShow = false
        vm.isEdit = false
        vm.$swal.fire({
          title: vm.$t('Successfully'),
          text: `${vm.$t('booking')} ${vm.bookingItemEdit.booking_name} ${vm.$t(
            'has_been_edited'
          )}`,
          type: 'success'
        })

        vm.loading = false
      } else {
        vm.loading = false
      }
    },
    setEditBooking(item) {
      const vm = this
      var beacon = JSON.stringify(item)
      vm.bookingItemEdit = JSON.parse(beacon)
      vm.isEdit = true
    },
    changePage() {
      const vm = this
      vm.offset = vm.pageNumber * vm.limit - vm.limit
      vm.getBookingConfigCalendar()
    },
    async postBookingConfigCalendar() {
      const vm = this
      vm.loading = true
      var res = await api.postBookingConfigCalendar({
        pageId: vm.selectedBot.pageid,
        body: {
          booking_name: vm.bookingItem.booking_name,
          google_calendar_id: vm.bookingItem.google_calendar_id, // optional
          image_url: vm.bookingItem.image_url,
          booking_description: vm.bookingItem.booking_description
        }
      })
      if (res.success && res.result) {
        res.result.toggle = false
        const newArray = [res.result].concat(vm.data)
        vm.data = newArray
        vm.isShow = false
        vm.$swal.fire({
          title: vm.$t('Successfully'),
          text: `${vm.$t('booking')} ${vm.bookingItem.booking_name} ${vm.$t('has_been_added')}`,
          type: 'success'
        })

        vm.loading = false
      } else {
        vm.loading = false
      }
    },
    async deleteBookingConfigCalendar(bookingItemEdit) {
      const vm = this
      var result = await vm.$swal.fire({
        title: vm.$t('Do you want to delete {name}?', {
          name: bookingItemEdit.booking_name
        }),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: vm.$t('Confirm'),
        cancelButtonText: vm.$t('cancel'),
        reverseButtons: true
      })
      if (result.value) {
        vm.loading = true
        var res = await api.deleteBookingConfigCalendar({
          pageId: vm.selectedBot.pageid,
          booking_config_id: bookingItemEdit.id
        })
        if (res.success) {
          vm.data = vm.data.filter(item => item.id !== bookingItemEdit.id)
          vm.isShow = false
          vm.isEdit = false
          vm.$swal.fire({
            title: vm.$t('Successfully'),
            text: `${vm.$t('booking')} ${bookingItemEdit.booking_name} ${vm.$t(
              'has_been_deleted'
            )}`,
            type: 'success'
          })

          vm.loading = false
        } else {
          vm.loading = false
        }
      }
    },
    async getBookingConfigCalendar() {
      const vm = this
      vm.loading = true
      vm.data = null
      const data = {
        pageId: vm.selectedBot.pageid,
        params: {
          limit: vm.limit,
          offset: vm.offset
        }
      }
      let response = await api.getBookingConfigCalendar(data)
      if (response.success && response.result) {
        response.result.map(item => {
          item.toggle = false
        })
        vm.data = response.result
        vm.pagelength = Math.ceil(response.total_count / vm.limit)
      }
      vm.loading = false
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/intent/calendar/Booking.vue